import BottomSheet, { BottomSheetView } from '@gorhom/bottom-sheet';
import * as React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

interface BSProps {
  style?: any;
  children: React.ReactNode;
}

export const BSheet = ({ style, children }: BSProps) => {
  const { styles, theme } = useStyles(stylesheet);

  const bottomSheetRef = React.useRef<BottomSheet>(null);

  const handleSheetChanges = React.useCallback((index: number) => {
    // console.log('handleSheetChanges', index);
  }, []);

  return (
    <View style={styles.container}>
      <BottomSheet
        ref={bottomSheetRef}
        onChange={handleSheetChanges}
        snapPoints={[185, 450]}
        handleStyle={{
          backgroundColor: theme.colors.background_2,
        }}
        handleIndicatorStyle={{
          backgroundColor: theme.colors.text.secondary,
          width: 120,
        }}
      >
        <BottomSheetView style={styles.contentContainer}>
          {children}
        </BottomSheetView>
      </BottomSheet>
    </View>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {},
  contentContainer: {
    flex: 1,
    backgroundColor: theme.colors.background_2,
  },
}));
